import { ArrowRightIcon, BodyText, BookIcon, Button, Caption, Chip } from '@farol-ds/react'
import { useGA4Dispatcher } from '@jusbrasil-web/shared-ga4'
import {
  COMPONENT_CLASS,
  COMPONENT_NAME,
  FEATURE_CLASS,
  FEATURE_NAME,
  GA4ClickEvent,
  GA4CustomComponentRenderedEvent,
  GA4FeatureUseEvent,
  REQUIRED_USER_STATUS,
  SELECTED_OPTION,
} from '@jusbrasil-web/shared-ga4-events'
import { useEffect } from 'react'

import styles from './styles.module.scss'

export type DoctrineContentProps = {
  data: {
    title: string
    doc: {
      artifact: string
      docId: number
      authors: string[]
      title: string
      text: string
      url: string
    }
  }
}

export function DoctrineContent(props: DoctrineContentProps) {
  const { data } = props

  const { sendGA4Event } = useGA4Dispatcher()
  const ga4Props = {
    componentClass: COMPONENT_CLASS.RELATED_DOCUMENT_POPOVER,
    componentName: COMPONENT_NAME.RELATED_DOCTRINE,
  }

  useEffect(() => {
    sendGA4Event(
      new GA4CustomComponentRenderedEvent({
        ...ga4Props,
        documentId: `${data.doc.artifact}:${data.doc.docId}`,
      })
    )
    // eslint-disable-next-line
  }, [])

  const trackDoctrineLinkClick = () => {
    sendGA4Event(
      new GA4ClickEvent({
        ...ga4Props,
        selectedOption: SELECTED_OPTION.FULL_DOCUMENT_ACCESS,
        resourceId: `${data.doc.artifact}:${data.doc.docId}`,
      })
    )
  }

  const onCopy = () => {
    sendGA4Event(
      new GA4FeatureUseEvent({
        ...ga4Props,
        featureClass: FEATURE_CLASS.COPY_CONTENT,
        featureName: FEATURE_NAME.COPY_DOCTRINE_CONTENT,
        resourceId: `${data.doc.artifact}:${data.doc.docId}`,
        requiredUserStatus: REQUIRED_USER_STATUS.UNAUTHENTICATED_USER,
      })
    )
  }

  return (
    <>
      <div>
        <Chip leftIcon={<BookIcon />} size="sm">
          {data.title}
        </Chip>
      </div>

      <BodyText size="md" className={styles.doctrineBody} onCopy={onCopy} asChild>
        <div dangerouslySetInnerHTML={{ __html: data.doc.text }} />
      </BodyText>

      <div className={styles.doctrineAuthor}>
        <Caption>
          <strong>{data.doc.authors.join(', ')}</strong>
        </Caption>
        <Caption>{data.doc.title}</Caption>
      </div>

      <div className={styles.contentFooter}>
        <Button rightIcon={<ArrowRightIcon />} asChild>
          <a
            href={data.doc.url}
            onClick={trackDoctrineLinkClick}
            target="_blank"
            rel="noopener noreferrer"
            title={`Acessar a obra ${data.doc.title}`}
          >
            Acessar obra completa
          </a>
        </Button>
      </div>
    </>
  )
}
